/**
 * A vigência de uma aplicação como o servidor a lê (#606): vale hoje quem começou até hoje e não
 * terminou antes de hoje, com "hoje" no fuso de São Paulo. A encerrada continua listada no destino,
 * mas não substitui a de cima nem entra nas contagens.
 */

import { hojeEmSaoPaulo } from '../../utils/hojeEmSaoPaulo';

export interface PeriodoDaAplicacao {
  startDate?: string | null;
  endDate?: string | null;
}

function dia(data: string | null | undefined): string {
  return data ? data.slice(0, 10) : '';
}

export function vigenteHoje(periodo: PeriodoDaAplicacao, hoje = hojeEmSaoPaulo()): boolean {
  const inicio = dia(periodo.startDate);
  const fim = dia(periodo.endDate);
  return (inicio === '' || inicio <= hoje) && (fim === '' || fim >= hoje);
}

/** "dd/mm/aaaa" do fim, quando a aplicação já terminou; nulo enquanto vale. */
export function encerradaEm(periodo: PeriodoDaAplicacao, hoje = hojeEmSaoPaulo()): string | null {
  const fim = dia(periodo.endDate);
  return fim !== '' && fim < hoje ? fim.split('-').reverse().join('/') : null;
}

/** "dd/mm/aaaa" do início, quando a aplicação só começa depois de hoje; nulo quando já começou. */
export function comecaEm(periodo: PeriodoDaAplicacao, hoje = hojeEmSaoPaulo()): string | null {
  const inicio = dia(periodo.startDate);
  return inicio !== '' && inicio > hoje ? inicio.split('-').reverse().join('/') : null;
}
